/** Utilitaires de formatage FR. */
export const fmtEUR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
};

export const fmtNum = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("fr-FR").format(n);
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
};

export const daysBetween = (isoDate, today = new Date()) => {
  if (!isoDate) return null;
  const d = new Date(isoDate);
  const t = new Date(today);
  return Math.max(0, Math.floor((t - d) / (1000 * 60 * 60 * 24)));
};

export const RISK_LABEL = { HAUT: "HAUT", MOYEN: "MOYEN", FAIBLE: "FAIBLE" };
export const RISK_CLASS = {
  HAUT: "pc-risk-haut",
  MOYEN: "pc-risk-moyen",
  FAIBLE: "pc-risk-faible",
};
